// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1xeuN","sidebar-menu":"_3Ecud","is-open":"_3hKxJ","menu-list":"_31VeR","menu-item":"_3e1Wc","menu-special-section-list":"_1E_vC","social-icons-wrapper":"_2Wpyu"};